__turbopack_context__.v({
  "button": "SaveShare-module-scss-module__7t50nG__button",
  "component": "SaveShare-module-scss-module__7t50nG__component",
  "dialogContent": "SaveShare-module-scss-module__7t50nG__dialogContent",
  "facebookIcon": "SaveShare-module-scss-module__7t50nG__facebookIcon",
  "input": "SaveShare-module-scss-module__7t50nG__input",
  "inputGroup": "SaveShare-module-scss-module__7t50nG__inputGroup",
  "inputLabel": "SaveShare-module-scss-module__7t50nG__inputLabel",
  "linkedinIcon": "SaveShare-module-scss-module__7t50nG__linkedinIcon",
  "resultsPreview": "SaveShare-module-scss-module__7t50nG__resultsPreview",
  "resultsPreviewList": "SaveShare-module-scss-module__7t50nG__resultsPreviewList",
  "resultsPreviewTitle": "SaveShare-module-scss-module__7t50nG__resultsPreviewTitle",
  "shareButton": "SaveShare-module-scss-module__7t50nG__shareButton",
  "shareButtons": "SaveShare-module-scss-module__7t50nG__shareButtons",
  "socialIcon": "SaveShare-module-scss-module__7t50nG__socialIcon",
  "submitButton": "SaveShare-module-scss-module__7t50nG__submitButton",
  "twitterIcon": "SaveShare-module-scss-module__7t50nG__twitterIcon",
});
